import { useContext } from "react";
import "./BottomNav.css";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, List, FilePlus2, Cog, ChartPie } from "lucide-react";
import { useTranslation } from "../../i18n/i18n";
import { UserPreferencesContext } from "../../contexts/UserPreferencesContext";

const BottomNav = () => {
	const { translate } = useTranslation();
	const { bottomNavStyle } = useContext(UserPreferencesContext);

	const navItems = [
		{ to: "/home", icon: <LayoutDashboard size={24} />, label: "home" },
		{ to: "/transactions-history", icon: <List size={24} />, label: "history" },
		{ to: "/add-transaction", icon: <FilePlus2 size={24} />, label: "add" },
		{ to: "/analysis", icon: <ChartPie size={24} />, label: "analysis" },
		{ to: "/settings", icon: <Cog size={24} />, label: "settings" },
	];

	const getNavClassName = () => {
		switch (bottomNavStyle) {
			case "floating":
				return "floating-bottom-nav-container";
			case "full":
				return "full-bottom-nav-container";
			case "fixed":
			default:
				return "fixed-bottom-nav-container";
		}
	};

	return (
		<div className={`bottom-nav-container glass-effect ${getNavClassName()}`}>
			<nav className="bottom-nav">
				{navItems.map(({ to, icon, label }) => (
					<NavLink
						key={label}
						to={to}
						aria-label={translate(`nav.${label}`)}
						className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
					>
						{icon}
						<span className="label">{translate(`nav.${label}`)}</span>
					</NavLink>
				))}
			</nav>
		</div>
	);
};

export default BottomNav;
